import React, { useCallback } from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import { Url } from '@wix/da-url';
import ArtStageArrowR from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import { useSelector } from 'react-redux';
import {
  getStashFolder,
  getStashNext,
  getStashPrev,
} from '../../../DeviationPage/redux/selectors';
import { getStashBiEventData } from '../../../Duperbrowse/redux/helpers';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
import BackToStashButton from '../BackToStashButton';
import StashPaddle from './StashPaddle';

import s from './StashPaddles.scss';

export interface Props {
  className?: string;
  paddleClassName?: string;
  iconClassName?: string;
}

const StashPaddles: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  paddleClassName,
  iconClassName,
}) => {
  const next = useSelector(getStashNext);
  const prev = useSelector(getStashPrev);
  const folder = useSelector(getStashFolder);
  const currentItem = useSelector(getCurrentItem);

  const openPrev = useCallback(() => {
    window.location.assign(Url.stashItemLink(prev ?? ''));
  }, [prev]);

  const openNext = useCallback(() => {
    window.location.assign(Url.stashItemLink(next ?? ''));
  }, [next]);

  if (!next && !prev && !folder) {
    return null;
  }

  return (
    <div className={classnames(s['root'], className)}>
      <StashPaddle
        disabled={!prev}
        className={classnames(s['prev'], paddleClassName)}
        onClick={openPrev}
        dataHook="arrowL"
        biData={currentItem && getStashBiEventData(currentItem, 'prev')}
      >
        <ArtStageArrowL
          customSizable
          disableDefaultColors
          className={classnames(s['icon'], iconClassName)}
        />
      </StashPaddle>
      {folder && <BackToStashButton />}
      <StashPaddle
        disabled={!next}
        className={classnames(s['next'], paddleClassName)}
        onClick={openNext}
        dataHook="arrowR"
        biData={currentItem && getStashBiEventData(currentItem, 'next')}
      >
        <ArtStageArrowR
          customSizable
          disableDefaultColors
          className={classnames(s['icon'], iconClassName)}
        />
      </StashPaddle>
    </div>
  );
};
StashPaddles.displayName = 'StashPaddles';

export default StashPaddles;
